import { Controller } from '@hotwired/stimulus'

let FancyboxLib = null

async function loadFancybox() {
  if (FancyboxLib) return FancyboxLib

  const module = await import('@fancyapps/ui')
  FancyboxLib = module.Fancybox || module.default?.Fancybox || module.default

  return FancyboxLib
}

export default class FancyboxController extends Controller {
  async connect() {
    this.Fancybox = await loadFancybox()

    this.Fancybox.unbind(this.element)
    this.Fancybox.bind('[data-fancybox]', {
      Hash: false,
      Carousel: {
        Video: {
          autoplay: true
        },
        Toolbar: {
          display: {
            left: [],
            middle: [],
            right: ['close']
          }
        }
      },
      Zoomable: {
        Panzoom: {
          maxScale: 'cover',
          panMode: 'mousemove',
          mouseMoveFactor: 1.1
        }
      },
      on: {
        'Carousel.contentReady': (fb, carousel, slide) => {
          const trigger = slide.triggerEl

          const feedVideo =
            trigger?.querySelector('video') ||
            trigger?.closest('[data-post]')?.querySelector('video')

          const modalVideo =
            slide.el?.querySelector('.f-html5video video') ||
            slide.el?.querySelector('video')

          if (!feedVideo || !modalVideo) return

          slide.feedVideo = feedVideo
          slide.modalVideo = modalVideo
          slide.originalMuted = feedVideo.muted
          slide.originalVolume = feedVideo.volume
          slide.originalPlaybackRate = feedVideo.playbackRate
          slide.wasPlaying = !feedVideo.paused

          feedVideo.muted = true

          modalVideo.currentTime = feedVideo.currentTime
          modalVideo.volume = feedVideo.volume
          modalVideo.playbackRate = feedVideo.playbackRate
          modalVideo.muted = slide.originalMuted

          if (slide.wasPlaying) {
            modalVideo.play().catch(() => {})
          }
        },

        close: (fb) => {
          const slide = fb.getSlide()

          if (!slide?.feedVideo || !slide?.modalVideo) return

          const { feedVideo, modalVideo } = slide

          feedVideo.currentTime = modalVideo.currentTime
          feedVideo.volume = modalVideo.volume
          feedVideo.playbackRate = modalVideo.playbackRate

          feedVideo.muted = slide.originalMuted

          if (slide.wasPlaying) {
            feedVideo.play().catch(() => {})
          }

          modalVideo.pause()
        }
      }
    })
  }

  disconnect() {
    this.Fancybox?.unbind(this.element)
  }
}
